export enum NotificationItemType {
  Error = "error",
  Information = "info",
  Success = "success",
  Warning = "warning",
}
